import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetStoresResquestParams,
  type StoresResponse,
  getStoresFn,
} from './ahafood/get-store-fn';
import { createStoreQueryKey } from '@/lib/query-key-utils';

export const useGetStores = (
  params: GetStoresResquestParams,
  opts?: Omit<UseQueryOptions<StoresResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  const { enabled: optsEnabled, ...restOpts } = opts ?? {};
  return useQuery<StoresResponse, Error>({
    queryKey: createStoreQueryKey(params), // Use normalized geohash-based key
    queryFn: () => getStoresFn(params), // Still pass exact lat/lng to API
    ...restOpts,
    // city_id is required by the API — never fire until it's resolved (the
    // by-point flow sets it async, so it can be empty on first render). Combine
    // with any caller-provided `enabled`.
    enabled: Boolean(params.city_id) && (optsEnabled ?? true),
  });
};
